<template>
  <div>
    <b-modal 
      id="th-ess-acc-modal" 
      ref="th-ess-acc-modal-ref" 
      hide-footer 
      :title="title"
    >
      <div
        v-if="customDescription !== ''"
        class="mb-5 mt-5"
      >
        <p class="ess-info-text">{{ formatText(customDescription) }}</p>
      </div>
      <div
        v-if="additionalInformation !== ''"
        class="mb-5 mt-5"
      >
        <p class="ess-info-text">{{ formatText(additionalInformation) }}</p>
      </div>
      <div
        v-if="dateMessages && dateMessages.length >=1"
        class="mb-5 mt-5"
      >
        <div
          v-for="(message, index) in dateMessages"
          :key="`message-${index}`"
        >
          <p><strong>{{ formatDate(message.dateFrom) }} - {{ formatDate(message.dateTo) }}</strong></p>
          <p class="ess-info-text">{{ formatText(message.name) }}</p>
        </div>
      </div>

      <div v-if="validSupplements.length">
        <div class="my-3" v-for="(supp, i) in validSupplements" :key="`supplement-${i}`">
          <p><strong>{{ supp.title }}</strong></p>
          <p class="ess-info-text">{{ formatText(supp.description) }}</p>
        </div>
      </div>
    </b-modal>
  </div>
</template>
  
<script>
import dayjs from '@/lib/dayjs'
export default {
  name: 'TouringHubEssInfoAcc',
  props: {
    additionalInformation: {
      type: String
    },
    customDescription: {
      type: String
    },
    dateRangeMessages: {
      type: Array
    }, 
    title: {
      type: String
    },
    date: {
      type: String
    },
    supplements : {
      type: Array,
      default: () => [],
    }
  },
  data () {
    return {
      dateMessages: [],
      validSupplements : [],
    }
  },
  mounted () {
    if (this.dateRangeMessages && this.dateRangeMessages.length) {
      this.getDateRangeMessages()
    }
    if (this.supplements && this.supplements.length){
      this.getSupplements();
    }
  },
  methods: {
    showModal() {
      this.$refs["th-ess-acc-modal-ref"].show();
    },
    getDateRangeMessages () {
      const messages = []
      this.dateRangeMessages.forEach((message) => {
        const isWithinRange = this.checkDateInRange(message.dateFrom, message.dateTo)
        if (isWithinRange) {
          messages.push(message)
        }
      })
      this.dateMessages = messages
    },
    getSupplements(){
      const validSupps = [];
      this.supplements.forEach((supp) => {
        if (supp && supp.dateFrom && supp.dateTo){
          const isWithinRange = this.checkDateInRange(supp.dateFrom, supp.dateTo)
          if (isWithinRange && supp.description && supp.description.trim()) {
            validSupps.push(supp)
          }
        }
      });
      this.validSupplements = validSupps;
    },
    checkDateInRange(dateFrom, dateTo){
      const dateToCheck = dayjs(new Date(this.date));
      const startDate = dayjs(new Date(dateFrom));
      const endDate = dayjs(new Date(dateTo));
      return dateToCheck.isBetween(startDate - 1, endDate + 1);
    },
    formatDate (date) {
      return dayjs(new Date(date)).format('dddd Do MMMM YYYY')
    },
    formatText (text) {
      if (!text) return ''
      // Bullet lines arrive as "\n. ... \t" - keep those as a single break so
      // the list stays tight. Any standalone newline (not the start of a bullet)
      // is expanded to a double break for more generous spacing.
      return text.replace(/\n(?!\.)/g, '\n\n')
    }
  },
}
</script>
  
  <style lang="scss">
  .places {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: auto;
    white-space: nowrap;
  }
  .place-select {
    cursor: pointer;
  }
  .active-place {
    font-weight: bold;
  }
  .ess-info-text {
    white-space: pre-line;
  }
  </style>